import { Stack } from "@mui/material";
import { useParams } from "react-router-dom";
import { Card } from "src/components/atoms/Card";
import { Text } from "@asayinc/component-library";
import { useProxyEventProposalsQuery } from "src/store/proxyEvent";
import { ProposalSection } from "./ProposalSection";
import { IProposal } from "src/store/proxyEvent/types";

// Placeholder sections for loading state
const LOADING_SECTIONS = [1, 2, 3, 4];

// Group proposals by groupNumber
function groupProposals(proposals: IProposal[]): IProposal[][] {
  const groups: Record<number, IProposal[]> = {};
  proposals.forEach((proposal) => {
    if (!groups[proposal.groupNumber]) {
      groups[proposal.groupNumber] = [];
    }
    groups[proposal.groupNumber].push(proposal);
  });
  return Object.values(groups);
}

export function ProposalsWithStats() {
  const { id } = useParams() as { id: string };
  const { data: proxyEventProposals, isLoading } = useProxyEventProposalsQuery({
    id,
  });

  const groupedProposals = proxyEventProposals
    ? groupProposals(proxyEventProposals)
    : [];

  const hasProposals = groupedProposals.length > 0;

  return (
    <Card title="Proposal breakdown">
      <Stack gap={6}>
        {isLoading ? (
          LOADING_SECTIONS.map((section, idx) => (
            <ProposalSection
              key={section}
              isLoading={isLoading}
              proposals={[]}
              idx={idx}
            />
          ))
        ) : hasProposals ? (
          groupedProposals.map((proposalGroup, idx) => (
            <ProposalSection key={idx} proposals={proposalGroup} idx={idx} />
          ))
        ) : (
          <Text variant="body2" sx={{ color: "text.secondary" }}>
            Proposals not available yet
          </Text>
        )}
      </Stack>
    </Card>
  );
}
